(function () {
    'use strict';

    angular.module('file')
        .controller('FileUpdateController', FileUpdateController);

    FileUpdateController.$inject = ['$state', 'fileDataSrvc', 'notificationSrvc', 'fileMessagesConst', 'errorNotificationSrvc'];

    function FileUpdateController($state, fileDataSrvc, notificationSrvc, fileMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpde: [],
            name_cpen: [],
            file: [],
            nonFieldErrors: []
        };
        self.fileData = {};
        self.downloadUrl = undefined;

        self.updateFile = updateFile;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getFile();
        }

        function getFile() {
            return fileDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                // cp-input-file clears fileData.file after load, so keep the link separately
                self.downloadUrl = response.file;
                // cp-input-file previews the file name
                response.file = response.file_name;
                delete response.file_name;
                self.fileData = response;

                delete self.fileData.date_modified;
                delete self.fileData.date_added;
                return response;
            });
        }

        function updateFile() {
            fileDataSrvc.update({
                pk: self.fileData.pk
            }, self.fileData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", fileMessagesConst.update);
                    $state.go('layout.file.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
